"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YouTubeVideo = exports.PosterImage = exports.HtmlVideo = void 0;
var _react = require("react");
var _reactYoutube = _interopRequireDefault(require("react-youtube"));
var _analytics = require("../analytics");
var _Image = _interopRequireDefault(require("./Image"));
var _index = _interopRequireDefault(require("./index.styled"));
require("./youtube.css");
var _lodashEs = require("lodash-es");
var _jsxRuntime = require("react/jsx-runtime");
const noop = function () {};
const HtmlVideo = function (_ref) {
  let {
    mp4,
    webm,
    showPoster,
    onEnd = noop,
    onReady = noop,
    onUpdate = noop,
    isPlaying = false,
    onPause = noop,
    ...props
  } = _ref;
  const videoRef = (0, _react.useRef)();
  let {
    current: stateChangeTimer
  } = (0, _react.useRef)();
  const handleVideoPause = function () {
    clearTimeout(stateChangeTimer);
    stateChangeTimer = setTimeout(function () {
      var _videoRef$current, _videoRef$current2, _videoRef$current3;
      if ((_videoRef$current = videoRef.current) !== null && _videoRef$current !== void 0 && _videoRef$current.paused && ((_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.currentTime) !== ((_videoRef$current3 = videoRef.current) === null || _videoRef$current3 === void 0 ? void 0 : _videoRef$current3.duration)) {
        onPause();
      }
    }, 500);
    /* HTML5 API sends pause and play events on seek, so we debounce the events to wait for for the final result. */
  };
  (0, _react.useEffect)(function () {
    if (isPlaying && videoRef.current) {
      videoRef.current.play();
    }
  }, [isPlaying, videoRef.current]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.HtmlVideo, {
    controls: true,
    showPoster: showPoster,
    onEnded: onEnd,
    onLoadedData: onReady,
    ref: videoRef,
    onPause: handleVideoPause,
    ...props,
    "data-testid": "HtmlVideo",
    children: [webm && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      src: webm,
      type: "video/webm"
    }), mp4 && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      src: mp4,
      type: "video/mp4"
    })]
  });
};
exports.HtmlVideo = HtmlVideo;
const YouTubeVideo = function (_ref2) {
  let {
    videoId,
    showPoster,
    setShowPoster = noop,
    isPlaying = false,
    onStateChange = noop,
    onEnd = noop,
    onPause = noop,
    onReady = noop,
    ...props
  } = _ref2;
  const YTPlayer = (0, _react.useRef)(false);
  let {
    current: stateChangeTimer
  } = (0, _react.useRef)();
  const handleKeyDown = function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (showPoster) {
        setShowPoster(false);
        if (YTPlayer.current) {
          YTPlayer.current.playVideo();
        }
      } else if (YTPlayer.current) {
        const state = YTPlayer.current.getPlayerState();
        if (state === 1) {
          // Playing
          YTPlayer.current.pauseVideo();
        } else {
          YTPlayer.current.playVideo();
        }
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (isPlaying && YTPlayer.current) {
      YTPlayer.current.playVideo();
    }
  }, [isPlaying, YTPlayer]);
  const onYTReady = function (event) {
    YTPlayer.current = event.target;
    const {
      duration,
      videoData
    } = event.target.playerInfo;
    const isPremiere = duration === 0 && videoData.title !== "";
    if (isPremiere && showPoster) {
      setShowPoster(false);
    }
    if (isPremiere || isPlaying) {
      YTPlayer.current.playVideo();
    }
  };
  const onStateChangeHandler = function (event) {
    clearTimeout(stateChangeTimer);
    onStateChange(event);
    stateChangeTimer = setTimeout(function () {
      switch (event.target.getPlayerState()) {
        case 0:
          onEnd(event);
          break;
        case 2:
          onPause(event);
          break;
        default:
      }
    }, 500);
    /* Youtube API sends pause and play events on seek, so we debounce the events to wait for for the final result. */
  };
  const options = {
    videoId,
    onReady: function (e) {
      onReady(e);
      onYTReady(e);
    },
    className: "youtube-iframe",
    containerClassName: `youtube-container ${showPoster ? "youtube-container-hide" : "youtube-container-show"}`,
    onStateChange: onStateChangeHandler,
    opts: {
      host: window.do_not_track ? "https://www.youtube-nocookie.com" : "https://www.youtube.com",
      playerVars: {
        rel: 0
      }
    },
    ...props
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "region",
    "aria-label": `YouTube video player: ${props.title || ""}`,
    tabIndex: 0,
    onKeyDown: handleKeyDown,
    "data-testid": "YouTubeVideo",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactYoutube.default, {
      ...options
    })
  });
};
exports.YouTubeVideo = YouTubeVideo;
const PosterImage = function (_ref3) {
  let {
    image,
    disableInteractiveVideo = false,
    fullscreen,
    showLoading = false
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Poster, {
    disableInteractiveVideo: disableInteractiveVideo,
    fullscreen: fullscreen,
    "data-testid": "PosterImage",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
      image: image,
      fullscreen: fullscreen
    }), showLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.LoadingIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Play, {})]
  });
};
exports.PosterImage = PosterImage;
const Video = function (_ref4) {
  let {
    interactiveVideo = {},
    image,
    title,
    showLoading = false,
    onStateChange = noop,
    onEnd = noop,
    onPause = noop,
    disableInteractiveVideo = false,
    ...props
  } = _ref4;
  const {
    youtube,
    ...html
  } = interactiveVideo;
  const [showPoster, setShowPoster] = (0, _react.useState)(!!image);
  const fireAnalytics = (0, _analytics.useAnalytics)("Video", {
    medium: youtube ? "youtube" : "html5"
  });
  const opts = {
    title,
    playerVars: {
      rel: 0
    },
    onPlay: (0, _lodashEs.debounce)(function () {
      setShowPoster(false);
      fireAnalytics("play");
    }, 500),
    onPause: function () {
      fireAnalytics("pause");
      onPause();
    },
    onEnd: function () {
      fireAnalytics("ended");
      onEnd();
    },
    onReady: function () {
      fireAnalytics("ready");
    },
    onStateChange,
    showPoster,
    setShowPoster,
    isPlaying: props.isPlaying
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Video, {
    ...props,
    "data-testid": "Video",
    children: [!disableInteractiveVideo && (youtube ? /*#__PURE__*/(0, _jsxRuntime.jsx)(YouTubeVideo, {
      videoId: youtube,
      ...opts
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(HtmlVideo, {
      ...html,
      ...opts
    })), showPoster && /*#__PURE__*/(0, _jsxRuntime.jsx)(PosterImage, {
      disableInteractiveVideo: disableInteractiveVideo,
      image: image,
      showLoading: showLoading,
      fullscreen: props.fullscreen
    })]
  });
};
var _default = exports.default = (0, _analytics.withAnalytics)(Video)({});